import React from "react";
import styled from "styled-components";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useAppContext } from "../../AppContext";
import BodyClassName from "react-body-classname";
import LayoutTop from "./LayoutTop";
import LayoutBottom from "./LayoutBottom";
import LoginPage from "../../Pages/LoginPage";


interface IProps {
  children: JSX.Element;
}
function InnerPageLayout (props: IProps) {
    const app = useAppContext();
    
    const user = app.user || { displayName: '', jobTitle: '' };
  
  
  return (
      <>
          <AuthenticatedTemplate>
              <>
              
                  <LayoutTop />
                  <div className="wrapper3 wrapper4">
            <div className="container-fluid">

                  {props.children}

                  </div>
                  </div>

                  <LayoutBottom />
              </>
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
              <LoginPage />
          </UnauthenticatedTemplate>
      </>
  
  );
};

export default InnerPageLayout;
